import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { UnorderedListOutlined } from '@ant-design/icons';

import { ChecklistItem, ChecklistItemPlacement, ChecklistItemStatusType, ReleaseStepType } from '@/types';
import { antGrey } from '../styles/globalStyles';
import { StepChecklistItems } from '../StepChecklistItems';
import { StepRunComponentProps } from '@/typescriptHelpers';
import { StepRunPanelSection } from './StepRunPanelSection';

interface ChecklistSectionProps {
    releaseStepType: ReleaseStepType;
    checklistItems: ChecklistItem[];
    stepRunComponentProps: StepRunComponentProps;
}

export const ChecklistSection: React.FC<ChecklistSectionProps> = ({
    stepRunComponentProps,
    releaseStepType,
    checklistItems,
}) => {
    const completedCount = checklistItems.filter(
        (item) => item.status?.status === ChecklistItemStatusType.Approved,
    ).length;
    const totalCount = checklistItems.length;

    return (
        <StepRunPanelSection
            icon={<UnorderedListOutlined style={{ color: antGrey.grey7, fontSize: 16 }} />}
            title="Checklist"
            titleExtra={
                <Text style={{ fontSize: 13, color: antGrey.grey6, marginLeft: 8 }}>
                    {completedCount} of {totalCount}
                </Text>
            }
        >
            <StepChecklistItems
                orgId={stepRunComponentProps.orgId}
                releaseId={stepRunComponentProps.releaseId}
                appId={stepRunComponentProps.appId}
                releaseStepType={releaseStepType}
                items={checklistItems}
                isEditing={false}
                onEditChecklistItem={() => {}}
                onAddComment={() => {}}
                placement={ChecklistItemPlacement.StepChecklist}
                onUpdateOrder={() => {}}
                stepRunComponentProps={stepRunComponentProps}
                shouldDisplayInReadOnlyMode
            />
        </StepRunPanelSection>
    );
};
